import React, {Component} from 'react'

import PropTypes from 'prop-types'

import StatusComponent from './Status.component'

class StatusContainer extends Component {
    static propTypes = {
      handleSort: PropTypes.func,
      handleRemoveFilter: PropTypes.func,
      handleFilter: PropTypes.func,
      sort: PropTypes.object,
      filters: PropTypes.array,
      customFilter: PropTypes.string
    }

    constructor(props) {
      super(props)

      this.state = {
        filters: []
      }
    }

    componentWillReceiveProps(newProps) {
      this.setState({
        filters: newProps.filters
      })
    }

    handleClearAllClick = (evt) => {
      if (evt) {
        evt.preventDefault()
      }

      // this.props.handleRemoveSearch()
      // this.props.handleSort(null)
      this.props.api.unsetSearch()
      this.props.api.setSort(null)

      this.props.handleFilter({})
      this.props.api.setCustomFilter(null)
      this.props.api.setCustomFilterId(null)
      this.props.api.setCustomFilterType(null)

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Status Clear All',
        type: 'Datatable'
      })
    }

    render() {
      const {api, sort, filters, search, i18n, handleSort, handleRemoveFilter, customFilter, handleRemoveSearch, analytics} = this.props
      const events = {
        handleClearAllClick: this.handleClearAllClick
      }

      if (filters.length < 1 && search === '') {
        return null
      }

      return (
        <StatusComponent
          analytics={analytics}
          api={api}
          events={events}
          sort={sort}
          search={search}
          filters={filters}
          customFilter={customFilter}
          i18n={i18n}
          handleRemoveSearch={handleRemoveSearch}
          handleSort={handleSort}
          handleRemoveFilter={handleRemoveFilter} />
      )
    }
}

export default StatusContainer
